import KTextField from "./KTextField";
import Themeable from "vuetify/lib/mixins/themeable";
import { getRoutePermissions } from "kinnect-helpers";
import {
	VCard,
	VCardTitle,
	VCol,
	VContainer,
	VDataIterator,
	VIcon,
	VListItem,
	VListItemAvatar,
	VListItemContent,
	VListItemSubtitle,
	VListItemTitle,
	VRow,
	VSheet
} from "vuetify/lib";

export default {
	name: "KPageIndex",

	mixins: [ Themeable ],

	props: {
		autoSort: {
			default: true,
			type: Boolean
		},

		items: Array
	},

	data: () => ( {
		search: null
	} ),

	computed: {
		visibleItems() {
			return this.items.filter( item => {
				if ( item.to ) {
					const routePermissions = getRoutePermissions( this.$router.resolve( item.to ).route );

					return this.$can( routePermissions );
				}

				return true;
			} );
		}
	},

	methods: {
		hasRoutePermissions( route ) {
			let routePermissions;

			if ( route.meta ) {
				if ( typeof route.meta.auth === "string" || Array.isArray( route.meta.auth ) ) {
					routePermissions = route.meta.auth;
				} else if ( typeof route.meta.auth === "object" && route.meta.auth.roles ) {
					routePermissions = route.meta.auth.roles;
				}
			}

			return this.$can( routePermissions );
		},

		genItem( item ) {
			return <VCol cols={12} sm={6} md={4}>
				<VCard
					color={this.isDark ? "grey darken-4" : "grey lighten-4"}
					exact={item.to.name === "front"}
					height="100%"
					hover
					elevation={0}
					href={item.target ? item.to : null}
					target={item.target ? item.target : null}
					to={item.target ? null : item.to}
				>
					<VCardTitle class="px-4 py-1">
						<VListItem class="list-item--auto-height">
							{item.icon && <VListItemAvatar>
								<VIcon xLarge>{item.icon}</VIcon>
							</VListItemAvatar>}

							<VListItemContent>
								{item.title && <VListItemTitle>{item.title}</VListItemTitle>}
								{item.description && <VListItemSubtitle>{item.description}</VListItemSubtitle>}
							</VListItemContent>
						</VListItem>
					</VCardTitle>
				</VCard>
			</VCol>;
		}
	},

	render() {
		return <VCard>
			<VSheet class="pa-3" color="primary" tile>
				<KTextField
					clearable
					dark
					flat
					hideDetails
					label="Search"
					prependInnerIcon="search"
					soloInverted
					vModel={this.search}
				></KTextField>
			</VSheet>

			<VContainer fluid>
				<VDataIterator
					hideDefaultFooter
					items={this.visibleItems}
					itemsPerPage={-1}
					scopedSlots={{
						default: ( { items } ) => <VRow>{items.map( this.genItem )}</VRow>
					}}
					search={this.search}
					sortBy={this.autoSort ? "title" : null}
				></VDataIterator>
			</VContainer>
		</VCard>;
	}
};
